import logo from './logo.svg';
import './App.css';
import LoginSignup from './Components/LoginSignup/LoginSignup';
import index from './index.css';
function App() {
  return (
   <div>
      <LoginSignup /> 
    </div>
  );
}

export default App;
